export const LEARN_LANGUAGES = {
  ENG: {
    alpha2: 'en',
    title: 'English',
    image: 'images/flags/gb.svg'
  },
  SPA: {
    alpha2: 'es',
    title: 'Spanish',
    image: 'images/flags/es.svg'
  },
  FRA: {
    alpha2: 'fr',
    title: 'French',
    image: 'images/flags/fr.svg'
  },
  ITA: {
    alpha2: 'it',
    title: 'Italian',
    image: 'images/flags/it.svg'
  },
  DEU: {
    alpha2: 'de',
    title: 'German',
    image: 'images/flags/de.svg'
  },
  POR: {
    alpha2: 'pt',
    title: 'Portuguese',
    image: 'images/flags/pt.svg'
  },
  SWE: {
    alpha2: 'sv',
    title: 'Swedish',
    image: 'images/flags/sv.svg'
  },
  TUR: {
    alpha2: 'tr',
    title: 'Turkish',
    image: 'images/flags/tr.svg'
  },
  NLD: {
    alpha2: 'nl',
    title: 'Dutch',
    image: 'images/flags/nl.svg'
  },
  POL: {
    alpha2: 'pl',
    title: 'Polish',
    image: 'images/flags/pl.svg'
  },
  DAN: {
    alpha2: 'dk',
    title: 'Danish',
    image: 'images/flags/dk.svg'
  },
  NOR: {
    alpha2: 'no',
    title: 'Norwegian',
    image: 'images/flags/no.svg'
  },
  IND: {
    alpha2: 'id',
    title: 'Indonesian',
    image: 'images/flags/id.svg'
  },
  RUS: {
    alpha2: 'ru',
    title: 'Russian',
    image: 'images/flags/ru.svg'
  },
  QMS: {
    alpha2: 'es',
    title: 'Mexican',
    image: 'images/flags/ms.svg'
  }
};

export const DEFAULT_LEARN_LANGUAGE = 'ENG';
export const ENGLISH_DEFAULT_LEARN_LANGUAGE = 'SPA';
export const ENGLISH_LOCALES = ['en', 'en_GB'];

export const isLearnLanguageValid = (learnLanguage) =>
  Boolean(LEARN_LANGUAGES[learnLanguage]);
